"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.legal_enDe = void 0;
exports.legal_enDe = {
    metaData: {
        prismicId: 'Zp4QrRMAAC4AqE2n',
        type: 'comparisontable',
        uid: 'legal',
        lang: 'en-de',
        lastPublished: '2024-09-20T15:21:33+0000',
    },
    tableData: {
        title: 'Legal',
        collapsibleSections: false,
        hideDetails: false,
        tableData: [
            {
                section: {
                    title: '',
                },
                rows: [
                    [
                        {
                            cellId: 'table_row$3de57e10-ff58-47c5-97b8-0d1322513375_header',
                            text: 'Coverage overview',
                            description: null,
                        },
                        {
                            cellId: 'table_row$3de57e10-ff58-47c5-97b8-0d1322513375_0',
                            type: 'CTA',
                            title: 'Basic',
                            grey: false,
                            narrow: false,
                            buttonCaption: 'Get a quote',
                            href: 'https://app.feather-insurance.com/policies/legal/pre-quote/intro',
                        },
                        {
                            cellId: 'table_row$3de57e10-ff58-47c5-97b8-0d1322513375_1',
                            type: 'CTA',
                            title: 'Advanced',
                            grey: false,
                            narrow: false,
                            buttonCaption: 'Get a quote',
                            href: 'https://app.feather-insurance.com/policies/legal/pre-quote/intro',
                        },
                    ],
                    [
                        {
                            cellId: 'table_row$9c1d4a39-467e-4dc3-83e6-52f6b0ab5d1b_header',
                            text: 'Deductible',
                            description: null,
                        },
                        {
                            cellId: 'table_row$9c1d4a39-467e-4dc3-83e6-52f6b0ab5d1b_0',
                            text: 'Up to €300',
                        },
                        {
                            cellId: 'table_row$9c1d4a39-467e-4dc3-83e6-52f6b0ab5d1b_1',
                            text: 'Up to €300',
                        },
                    ],
                    [
                        {
                            cellId: 'table_row$b53e272c-e6b5-43ed-9c86-8ae67180e894_header',
                            text: 'Worldwide coverage',
                            description: null,
                        },
                        {
                            cellId: 'table_row$b53e272c-e6b5-43ed-9c86-8ae67180e894_0',
                            text: '€250,000',
                        },
                        {
                            cellId: 'table_row$b53e272c-e6b5-43ed-9c86-8ae67180e894_1',
                            text: '€500,000',
                        },
                    ],
                    [
                        {
                            cellId: 'table_row$4b187606-13db-47f2-8b4b-fae732061f84_header',
                            text: 'Initial consultation with a lawyer or mediator',
                            description: null,
                        },
                        {
                            cellId: 'table_row$4b187606-13db-47f2-8b4b-fae732061f84_0',
                            checkmarkValue: true,
                        },
                        {
                            cellId: 'table_row$4b187606-13db-47f2-8b4b-fae732061f84_1',
                            checkmarkValue: true,
                        },
                    ],
                ],
            },
            {
                section: {
                    title: 'Personal',
                },
                rows: [
                    [
                        {
                            cellId: 'table_row$ba63a0da-9d00-4700-8061-bbbf5cd91b7f_header',
                            text: 'Disputes about personal contracts',
                            description: null,
                        },
                        {
                            cellId: 'table_row$ba63a0da-9d00-4700-8061-bbbf5cd91b7f_0',
                            description: '6-month waiting period',
                            checkmarkValue: true,
                        },
                        {
                            cellId: 'table_row$ba63a0da-9d00-4700-8061-bbbf5cd91b7f_1',
                            checkmarkValue: true,
                        },
                    ],
                    [
                        {
                            cellId: 'table_row$6eafee52-0e8f-4a99-9992-5882b6495bca_header',
                            text: 'Social law',
                            description: null,
                        },
                        {
                            cellId: 'table_row$6eafee52-0e8f-4a99-9992-5882b6495bca_0',
                            checkmarkValue: true,
                        },
                        {
                            cellId: 'table_row$6eafee52-0e8f-4a99-9992-5882b6495bca_1',
                            checkmarkValue: true,
                        },
                    ],
                    [
                        {
                            cellId: 'table_row$0c0da6c0-6b30-412e-a124-296e595b0a04_header',
                            text: 'Administrative law',
                            description: null,
                        },
                        {
                            cellId: 'table_row$0c0da6c0-6b30-412e-a124-296e595b0a04_0',
                            description: '6-month waiting period',
                            checkmarkValue: true,
                        },
                        {
                            cellId: 'table_row$0c0da6c0-6b30-412e-a124-296e595b0a04_1',
                            description: '3-month waiting period',
                            checkmarkValue: true,
                        },
                    ],
                    [
                        {
                            cellId: 'table_row$4d57dfd3-7cb0-4a60-bb94-968ed539b199_header',
                            text: 'University admission disputes',
                            description: null,
                        },
                        {
                            cellId: 'table_row$4d57dfd3-7cb0-4a60-bb94-968ed539b199_0',
                            checkmarkValue: false,
                        },
                        {
                            cellId: 'table_row$4d57dfd3-7cb0-4a60-bb94-968ed539b199_1',
                            description: '5-years waiting period',
                            checkmarkValue: true,
                        },
                    ],
                    [
                        {
                            cellId: 'table_row$31fce29c-ecff-49db-a361-cb7d86dfd90b_header',
                            text: 'Legal advice about family and inheritance law',
                            description: null,
                        },
                        {
                            cellId: 'table_row$31fce29c-ecff-49db-a361-cb7d86dfd90b_0',
                            text: '€250 / legal case',
                            description: '1-year waiting period',
                        },
                        {
                            cellId: 'table_row$31fce29c-ecff-49db-a361-cb7d86dfd90b_1',
                            text: '€2,500 / legal case',
                            description: '1-year waiting period',
                        },
                    ],
                    [
                        {
                            cellId: 'table_row$e58fd08f-9f41-4293-b3dd-69ce49c4c9cf_header',
                            text: 'Online copyright infringements',
                            description: null,
                        },
                        {
                            cellId: 'table_row$e58fd08f-9f41-4293-b3dd-69ce49c4c9cf_0',
                            text: 'Only initial consultation',
                        },
                        {
                            cellId: 'table_row$e58fd08f-9f41-4293-b3dd-69ce49c4c9cf_1',
                            text: '€1,000 / year',
                        },
                    ],
                    [
                        {
                            cellId: 'table_row$98dd5fb7-7d2d-4705-b0cb-8b121632e405_header',
                            text: 'Reviewing the contract before signing',
                            description: null,
                        },
                        {
                            cellId: 'table_row$98dd5fb7-7d2d-4705-b0cb-8b121632e405_0',
                            checkmarkValue: false,
                        },
                        {
                            cellId: 'table_row$98dd5fb7-7d2d-4705-b0cb-8b121632e405_1',
                            checkmarkValue: false,
                        },
                    ],
                    [
                        {
                            cellId: 'table_row$9626f9e3-e14b-4728-912c-0bab9e45c708_header',
                            text: 'Matters relating to immigration',
                            description: null,
                        },
                        {
                            cellId: 'table_row$9626f9e3-e14b-4728-912c-0bab9e45c708_0',
                            checkmarkValue: false,
                        },
                        {
                            cellId: 'table_row$9626f9e3-e14b-4728-912c-0bab9e45c708_1',
                            checkmarkValue: false,
                        },
                    ],
                ],
            },
            {
                section: {
                    title: 'Traffic',
                },
                rows: [
                    [
                        {
                            cellId: 'table_row$91e6db07-f689-4d4f-aad5-ea2e63fb1814_header',
                            text: 'Disputes after traffic accidents',
                            description: null,
                        },
                        {
                            cellId: 'table_row$91e6db07-f689-4d4f-aad5-ea2e63fb1814_0',
                            checkmarkValue: true,
                        },
                        {
                            cellId: 'table_row$91e6db07-f689-4d4f-aad5-ea2e63fb1814_1',
                            checkmarkValue: true,
                        },
                    ],
                    [
                        {
                            cellId: 'table_row$460cd168-ef31-411e-9869-028fbd447d92_header',
                            text: 'Administrative offences',
                            description: null,
                        },
                        {
                            cellId: 'table_row$460cd168-ef31-411e-9869-028fbd447d92_0',
                            checkmarkValue: true,
                        },
                        {
                            cellId: 'table_row$460cd168-ef31-411e-9869-028fbd447d92_1',
                            checkmarkValue: true,
                        },
                    ],
                    [
                        {
                            cellId: 'table_row$d8bf6ea6-ccb2-44fe-af1f-b243a114f1da_header',
                            text: 'Disputes about contracts',
                            description: null,
                        },
                        {
                            cellId: 'table_row$d8bf6ea6-ccb2-44fe-af1f-b243a114f1da_0',
                            checkmarkValue: true,
                        },
                        {
                            cellId: 'table_row$d8bf6ea6-ccb2-44fe-af1f-b243a114f1da_1',
                            checkmarkValue: true,
                        },
                    ],
                ],
            },
            {
                section: {
                    title: 'Professional',
                },
                rows: [
                    [
                        {
                            cellId: 'table_row$3cb71081-6b23-4771-a06d-cf19a0bfaa1a_header',
                            text: 'Wrongful termination, warnings or unfair assessments',
                            description: null,
                        },
                        {
                            cellId: 'table_row$3cb71081-6b23-4771-a06d-cf19a0bfaa1a_0',
                            description: '6-month waiting period',
                            checkmarkValue: true,
                        },
                        {
                            cellId: 'table_row$3cb71081-6b23-4771-a06d-cf19a0bfaa1a_1',
                            description: '3-month waiting period',
                            checkmarkValue: true,
                        },
                    ],
                    [
                        {
                            cellId: 'table_row$1a9f20a1-a268-4907-a5a8-505e01a60b4e_header',
                            text: 'Advice on termination agreement',
                            description: null,
                        },
                        {
                            cellId: 'table_row$1a9f20a1-a268-4907-a5a8-505e01a60b4e_0',
                            text: '€1000 / year',
                            description: '6-month waiting period',
                        },
                        {
                            cellId: 'table_row$1a9f20a1-a268-4907-a5a8-505e01a60b4e_1',
                            text: '€1000 / year',
                            description: '3-month waiting period',
                        },
                    ],
                    [
                        {
                            cellId: 'table_row$6ff79355-9558-4201-b25c-0eb106c2c7e9_header',
                            text: 'Protection against discrimination at work place',
                            description: null,
                        },
                        {
                            cellId: 'table_row$6ff79355-9558-4201-b25c-0eb106c2c7e9_0',
                            description: '6-month waiting period',
                            checkmarkValue: true,
                        },
                        {
                            cellId: 'table_row$6ff79355-9558-4201-b25c-0eb106c2c7e9_1',
                            description: '3-month waiting period',
                            checkmarkValue: true,
                        },
                    ],
                    [
                        {
                            cellId: 'table_row$d86c26d9-25f9-4c73-8f1a-109cf1f52842_header',
                            text: 'Self-employed secondary job',
                            description: null,
                        },
                        {
                            cellId: 'table_row$d86c26d9-25f9-4c73-8f1a-109cf1f52842_0',
                            checkmarkValue: false,
                        },
                        {
                            cellId: 'table_row$d86c26d9-25f9-4c73-8f1a-109cf1f52842_1',
                            text: 'Max turnover of €22,000',
                            description: '3-month waiting period',
                        },
                    ],
                    [
                        {
                            cellId: 'table_row$df34220b-1f88-45fc-8993-bb3b5a5587b8_header',
                            text: 'Full-time freelance / self-employment',
                            description: null,
                        },
                        {
                            cellId: 'table_row$df34220b-1f88-45fc-8993-bb3b5a5587b8_0',
                            checkmarkValue: false,
                        },
                        {
                            cellId: 'table_row$df34220b-1f88-45fc-8993-bb3b5a5587b8_1',
                            checkmarkValue: false,
                        },
                    ],
                ],
            },
        ],
    },
};
